<script setup>
  import { computed } from 'vue'

  import { useClubRouter } from '@/features/router/useClubRouer.js'

  defineProps({
    separator: {
      type: String,
    },
  })

  const breadcrumbs = defineModel()

  const router = useClubRouter()

  const items = computed(() => {
    return breadcrumbs.value.map((item, index) => ({
      title: item.label,
      href: item.to,
      isLast: index === breadcrumbs.value.length - 1,
      onClick: () => {
        if (item.to && !item.isLast) {
          router.push(item.to)
        }
      },
    }))
  })
</script>

<template>
  <div class="custom-breadcrumb">
    <template v-for="(item, index) of items" :key="index">
      <a v-if="item.href && !item.isLast" class="breadcrumb-item" @click="item.onClick">
        {{ $te(item.title) ? $t(item.title) : item.title }}
      </a>
      <span v-else class="breadcrumb-item current">
        {{ $te(item.title) ? $t(item.title) : item.title }}
      </span>
      <span v-if="!item.isLast" class="separator">
        <template v-if="separator">
          {{ separator }}
        </template>

        <template v-else>
          <i class="pi pi-chevron-right separator"></i>
        </template>
      </span>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .custom-breadcrumb {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 16px;
    font-size: 14px;

    .breadcrumb-item {
      &:not(.current):hover {
        cursor: pointer;
        text-decoration: underline;
      }

      &:first-child {
        font-weight: 700;
        font-size: 20px;
      }

      // show the last item for mobile view
      @include breakpoint('mobile') {
        display: none;

        &:last-child {
          display: block;
        }
      }
    }

    .separator {
      font-size: 12px;

      @include breakpoint('mobile') {
        display: none;
      }
    }
  }
</style>
